import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const Team_5 = (props: RealEstateDataPageComponentData) => {
  const { items, title, titleElement, opacityValue, titleColor, titleHexa, columns } = props

  const normalizedOpacity = Number(opacityValue) / 100

  function columnByString(columns: string) {
    switch (columns) {
      case '4':
        return '3'
      case '3':
        return '4'
      case '2':
        return '6'
      case '1':
        return '12'
      default:
        return '3'
    }
  }

  console.log(columns)

  return (
    <section className="team-5 p-b-config">
      <Container fluid>
        {title && (
          <Row className="mb-5">
            <Col xs={12}>
              <ElementHTML
                elementType={titleElement ?? 'h1'}
                children={title ?? ''}
                className={`mb-4 text-center ${titleColor}`}
                style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
              />
            </Col>
          </Row>
        )}
        <Row>
          {items &&
            items.map((teamMember, index) => (
              <Col
                xs={12}
                lg={columnByString(columns || '4')}
                key={index}
                className="mb-5"
              >
                <div className="position-relative hover-container">
                  <div
                    className={'opacity-background'}
                    style={{
                      backgroundColor: '#6b6b6b6',
                      opacity:
                        opacityValue && opacityValue !== '0'
                          ? Number(opacityValue) !== 100
                            ? normalizedOpacity
                            : 1
                          : 0,
                    }}
                  ></div>
                  <Image
                    className="no-border"
                    objectFit="cover"
                    alt="about-us-img"
                    image={teamMember.image_gatsby!!}
                    hrefImage={teamMember.image}
                    style={{ height: '50vh' }}
                  />
                  <div className="hover-overlay"></div>
                  <div className="overlay-content p-5">
                    <h4 className="text-white mb-0">{teamMember.title}</h4>
                    <p className="text-white">{teamMember.subtitle}</p>
                    <hr
                      style={{
                        border: 'none',
                        borderTop: '1px solid white',
                      }}
                    />
                    <p className="text-white">{teamMember.paragraph}</p>
                  </div>
                  <div
                    className="position-absolute bottom-0 start-0 ps-5 pb-3 hide-on-hover"
                    style={{ zIndex: '3' }}
                  >
                    <h4 className="text-white mb-0">{teamMember.title}</h4>
                    <p className="text-white">{teamMember.subtitle}</p>
                  </div>
                </div>
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  )
}

export default Team_5
